import { Col, Radio, Row } from 'antd';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { width } from 'styled-system';

const StyledRadioGroup = styled(Radio.Group)`
  ${width};
  width: 100%;
`;

export function RadioGroupControl({ settings, ...props }) {
  const { options, span = 24, ...rest } = settings;

  return (
    <StyledRadioGroup {...rest} {...props}>
      <Row>
        {options?.map(option => (
          <Col key={option.value} span={span}>
            <Radio value={option.value}>{option.label}</Radio>
          </Col>
        ))}
      </Row>
    </StyledRadioGroup>
  );
}

RadioGroupControl.propTypes = {
  name: PropTypes.string,
  value: PropTypes.any,
  settings: PropTypes.any,
  onChange: PropTypes.func,
};
